import styled, { css } from 'styled-components';
import colours from 'theme/atoms/colours';

export const profileTagBase = css`
  display: inline;
  padding: 0 2px;
  background-color: transparent;
  border-radius: 5px;
  cursor: pointer;
  color: ${colours.accents.blue};
  font-weight: 600;
  transition: background-color 0.15s ease;

  svg {
    stroke-width: 2;
  }

  svg path {
    stroke: ${colours.accents.blue};
  }
`;

export const ProfileIcon = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin-right: 0.15em;
  height: 1em;
  width: 1em;
  transform: translateY(-0.06em);

  svg {
    display: block;
    width: 0.9em;
    height: 0.9em;
  }
`;

export const ProfileIconUser = styled(ProfileIcon)`
  svg path {
    fill: ${colours.accents.blue};
  }
`;

export const ProfileTag = styled.span`
  ${profileTagBase}
`;

export const InlineTagWrapper = styled('span')`
  display: inline-flex;
  vertical-align: baseline;
  align-items: baseline;

  & > div {
    display: inline-flex;
    align-items: baseline;
    justify-content: flex-start;
    min-width: 0;
    min-height: 0;
    position: static;
  }
`;

export const ProfileTagTrigger = styled('button')<{ $isOpen: boolean }>`
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  ${profileTagBase}
  border: 0;
  margin: 0;
  user-select: none;

  &:disabled {
    cursor: default;
  }

  &:not(:disabled):hover {
    background-color: ${colours.neutral[200]};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${colours.primary[500]};
    outline-offset: 2px;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    `
      background-color: ${colours.neutral[200]};
    `}
`;
